import { DevtoolsOptions } from 'zustand/middleware';

export const devtoolsDefaultOption: DevtoolsOptions = {
  enabled: process.env.NODE_ENV !== 'production',
};
